import type { VerificationPayeeResult } from '@shared/transactions-types';
import { t } from '@luna/i18n';

export const getLocalizedVerificationPayeeResult = (
    payeeResult?: VerificationPayeeResult | null,
): string => {
    const map: Record<VerificationPayeeResult, string> = {
        VERIFIED_NAME: t('transaction.vopResult.match'),
        SIMILAR_NAME: t('transaction.vopResult.closeMatch'),
        CHECK_NAME: t('transaction.vopResult.noMatch'),
        NOT_AVAILABLE: t('transaction.vopResult.notPossible'),
        NOT_SUPPORTED: t('transaction.vopResult.notSupported'),
    };

    if (payeeResult) {
        return map[payeeResult] ?? payeeResult;
    }

    return '';
};
